import { useEffect, useState } from 'react'

const messages = [
  '환경은 자동으로, 관리는 간단하게.',
  '당신의 공간을 스스로 관리하게 만드세요.',
  '센서가 일하고, 당신은 결정만 하세요.',
  '환경 관리, 이제는 시스템의 역할입니다.',
  '운영의 기준을 데이터로 바꾸세요.'
]

export default function RotatingMessage() {
  const [index, setIndex] = useState(0)
  const [fade, setFade] = useState(true)

  useEffect(() => {
    const interval = setInterval(() => {
      // fade-out 시작
      setFade(false)

      // fade-out 끝나는 시점에 문구 교체
      setTimeout(() => {
        setIndex((prev) => (prev + 1) % messages.length)
        setFade(true) // fade-in
      }, 800) // fade-out 시간과 동일
    }, 3000) // 3초마다 전환

    return () => clearInterval(interval)
  }, [])

  return (
    <p
      className={`mt-2 text-center text-sm text-gray-600 transition-opacity duration-500 ${
        fade ? 'opacity-100' : 'opacity-0'
      }`}
    >
      {messages[index]}
    </p>
  )
}
